/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetClaimShares200ResponseDataInner } from './GetClaimShares200ResponseDataInner';
import {
    GetClaimShares200ResponseDataInnerFromJSON,
    GetClaimShares200ResponseDataInnerFromJSONTyped,
    GetClaimShares200ResponseDataInnerToJSON,
    GetClaimShares200ResponseDataInnerToJSONTyped,
} from './GetClaimShares200ResponseDataInner';

/**
 * 
 * @export
 * @interface GetClaimShares200Response
 */
export interface GetClaimShares200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetClaimShares200Response
     */
    success?: boolean;
    /**
     * 
     * @type {Array<GetClaimShares200ResponseDataInner>}
     * @memberof GetClaimShares200Response
     */
    data?: Array<GetClaimShares200ResponseDataInner>;
}

/**
 * Check if a given object implements the GetClaimShares200Response interface.
 */
export function instanceOfGetClaimShares200Response(value: object): value is GetClaimShares200Response {
    return true;
}

export function GetClaimShares200ResponseFromJSON(json: any): GetClaimShares200Response {
    return GetClaimShares200ResponseFromJSONTyped(json, false);
}

export function GetClaimShares200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClaimShares200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetClaimShares200ResponseDataInnerFromJSON)),
    };
}

export function GetClaimShares200ResponseToJSON(json: any): GetClaimShares200Response {
    return GetClaimShares200ResponseToJSONTyped(json, false);
}

export function GetClaimShares200ResponseToJSONTyped(value?: GetClaimShares200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetClaimShares200ResponseDataInnerToJSON)),
    };
}

